module.exports = __webpack_public_path__ + "img/hand-lizard.d7f4d4a9.svg";